import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/_app/admin/agent/runs/$runId/artifacts/$artifactId',
)({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/admin/agent/$runId',
            params: { runId: params.runId },
            search: { artifact: params.artifactId },
            replace: true,
        });
    },
});
